import React from 'react';

// STARKKE wordmark reproduced as elegant typography (not an image)
const Logo = ({ dark = false, small = false }) => {
  const color = dark ? '#f4efe6' : '#1b2331';
  const gold = '#b0894f';
  return (
    <div className="flex flex-col leading-none select-none">
      <span
        className="brand-mark"
        style={{
          color,
          fontSize: small ? '1.35rem' : '1.7rem',
          letterSpacing: '0.16em',
          fontWeight: 300,
        }}
      >
        STARKKE
      </span>
      <span
        className="font-sans-elegant"
        style={{
          color: gold,
          fontSize: small ? '0.5rem' : '0.6rem',
          letterSpacing: '0.42em',
          fontWeight: 400,
          marginTop: '2px',
        }}
      >
        IMMOBILIER
      </span>
    </div>
  );
};

export default Logo;
